// extracted by mini-css-extract-plugin
export var activityContainer = "_k8-0";
export var typingIndicatorContainer = "_k8-1";
export var typingIndicatorDot = "_k8-2";
export var wave = "_k8-3";